<template>
  <div class="message-change">
      <div class="header"><i style="display: inline-block;width: 2px; height: 14px; background-color: #0A80E6;border-radius: 6px;margin-right: 5px;margin-top: 8px;float: left;"></i> <span style="float: left">预警消息</span><span style="float: right;margin-right: 20px;cursor: pointer;" @click="rollback"><a-icon type="rollback" style="color: #0A80E6;"/> 返回</span></div>
       <div class="title"><p class="til">【{{message.title}}】{{message.content}}</p> <span class="data">{{message.time}}</span></div>
       <div class="content">
        <p style="font-size: 14px;margin-bottom: 10px;">以下信息来源于证书监控 <span style="color:#c1c1c1;font-size: 12px;">（本次监控较上次监控的差异分析）</span></p>
          <div class="table">
            <div class="table-til">成品证书</div>
            <a-table :rowKey="r => r.id" :pagination="false" :columns="columns" :data-source="certArr">
              <template v-if="record.items.length > 0" slot="items" slot-scope="record">
                <p v-for="(i, index) in record.items" :key="index">
                  <a-popover placement="top">
                    <template slot="content">
                        <p  v-if="i.content" style="width: 500px;word-wrap: break-word;word-break: break-all;overflow: hidden;">{{i.content}}</p>
                    </template>
                        <span v-if="i.content" class="item-type">{{i.content}}</span>
                  </a-popover>
                </p>
              </template>
               <template slot="changeNum" slot-scope="record">
                  <span :class="record.items.length > 0? 'blue': ''" @click="goMonitoring(record)">{{record.items.length}}</span>
              </template>
              <template slot="add" slot-scope="record">
                <div v-for="(i, index) in record.items" :key="index + '1'">
                  <p :class="record.items.length > 0? 'blue': ''" @click="goMonitoring(record)">{{i.number}}</p>
                </div>
              </template>
            </a-table>
          </div>
           <div class="table">
            <div class="table-til">关键件证书</div>
            <a-table :rowKey="r => r.id" :pagination="false" :columns="columnsK" :data-source="keyArr">
              <template v-if="record.items.length > 0" slot="items" slot-scope="record">
                <p v-for="(i, index) in record.items" :key="index">
                  <a-popover placement="top">
                    <template slot="content">
                        <p  v-if="i.content" style="width: 500px;word-wrap: break-word;word-break: break-all;overflow: hidden;">{{i.content}}</p>
                    </template>
                        <span v-if="i.content" class="item-type">{{i.content}}</span>
                  </a-popover>
                </p>
              </template>
               <template slot="changeNum" slot-scope="record">
                  <span :class="record.items.length > 0? 'blue': ''" @click="goMonitoring(record)">{{record.items.length}}</span>
              </template>
              <template slot="add" slot-scope="record">
                <div v-for="(i, index) in record.items" :key="index + '1'">
                  <p :class="record.items.length > 0? 'blue': ''" @click="goMonitoring(record)">{{i.number}}</p>
                </div>
              </template>
            </a-table>
          </div>
        </div>
  </div>
</template>
<script>

import { getMessageChange} from '@/api/message'
import {formatDate, dateDiff} from '@/utils/date';
import {getFileSuffix,isAssetTypeAnImage,isAssetTypeOther} from '@/utils/index'

const align = 'center';

export default {
  name: 'messageChange',
  components: {},
  data() {
    return {
      roleId: '',
      certArr: [],
      keyArr: [],
      message: {},
      columns: [
        {
          title: '监控内容',
          dataIndex: 'type',
          align,
          width: 100
        },
        {
          title: '新增',
          scopedSlots: { customRender: 'changeNum'},
          align,
          width: 150
        },
        {
          title: '对应证书编号',
          scopedSlots: { customRender: 'add'},
          align,
          width: 180
        },
        {
          title: '备注',
          scopedSlots: { customRender: 'items'},
          width: 500
        },
      ],
      columnsK: [
        {
          title: '监控内容',
          dataIndex: 'type',
          align,
          width: 100
        },
        {
          title: '新增',
          scopedSlots: { customRender: 'changeNum'},
          align,
          width: 150
        },
        {
          title: '对应证书编号',
          scopedSlots: { customRender: 'add'},
          align,
          width: 180
        },
        {
          title: '备注',
          scopedSlots: { customRender: 'items'},
          width: 500
        },
      ],
    }
  },
  mounted() {
    let id = this.$route.query.id;
    this.roleId = this.$store.state.user.roles;
    this.getMessageChange(id);
  },
  // destroyed() {
  //   this.$bus.$off("reloadTop");
  // },
  created() {
    this.$bus.$emit('reloadTop');
  },
  methods: {
    rollback() {
      this.$router.push('/user/informCenter');
    },
    goMonitoring(record) {
      let len = record.items.length;
      let items = record.items;
      let number = [];
      if (len > 0) {
        items.map((i) => {
          number.push(i.number);
        })
        this.$router.push({name: 'certificate-monitoring', params: {number: number, certificateType: record.certType}});
      }
    },
    getMessageChange(id) {
      getMessageChange(id)
        .then(res => {
          if (res) {
            this.message = res.message;
            res.detail.map(i => {
              if (i.certType == '1') {
                this.certArr.push(i);
              } else {
                this.keyArr.push(i);
              }
            })
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    goHref(url) {
        window.open(url, '_blank');
    },
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    spliceChinese(val) {
      if (val) {
        var reg = /[\u4e00-\u9fa5]/g;
        if (val.match(reg)) {
            return val.match(reg).join('');
          } else {
            return val;
          }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.blue {
    color: #40a9ff;
    font-weight: 500;
    cursor: pointer;
}
.table-til {
  width: 100px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  background-color: rgba(213,89,80,.14);
  color: #D55950;
  text-align: center;
  margin-bottom: 10px;
}
.item-type {
    display: inline-block;
    width: 500px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;
    vertical-align: middle;
    cursor: pointer;
}
 .message-change {
     background-color: #fff;
     height: 100%;
     padding: 20px;
     overflow-y: auto;
     .header {
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        border-bottom: 1px solid #c1c1c1;
        margin-bottom: 10px;
     }
     .title {
         .til {
            display: inline-block;
            max-width: 800px;
            font-weight: 600;
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow:ellipsis;
            vertical-align: middle;
            text-indent: 20px;
            margin-right: 20px;
         }
         .data {
             font-size: 12px;
             color: #c1c1c1;
         }
     }
    .content {
        width: 100%;
        padding: 30px;
        .table {
            width: 100%;
            margin-top: 20px;
            p {
              height: 25px;
              line-height: 25px;
            }
        }
     }
  }
</style>

